import React, { useEffect, useMemo, useState, useRef } from "react"
import { Link } from "react-router-dom"
// import TableContainer from "../../components/Common/TableContainer"
//import components
// import Breadcrumbs from "../../components/Common/Breadcrumb"
import toastr, { options } from "toastr"
// import "./CategoryMst.css"

//redux
import axios from "../../axios"
import Select from "react-select"
import numeral from "numeral"
import {
  Col,
  Row,
  UncontrolledTooltip,
  Modal,
  ModalHeader,
  ModalBody,
  CardTitle,
  // Table,
  Button,
  Form,
  Input,
  FormFeedback,
  Label,
  Card,
  CardBody,
  DropdownToggle,
  UncontrolledDropdown,
  DropdownMenu,
  DropdownItem,
} from "reactstrap"
import {
  Divider, Tooltip, TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow, Table,
  TableBody,
  TextField, InputAdornment
} from "@material-ui/core"
import IconButton from '@material-ui/core/IconButton';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import {
  Button as CustomButton2,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  // Tooltip,
} from "@mui/material"
import { styled } from "@mui/system"
import { makeStyles } from "@material-ui/core/styles"
// import DeleteModal from "../../components/Common/DeleteModal"
import SweetAlert from "react-bootstrap-sweetalert"
import Switch from "react-switch"
import Backdrop from "@material-ui/core/Backdrop"
import Spinner from "react-spinkit"
import * as Yup from "yup"
import { useFormik } from "formik"
// import { toggleLeftmenu } from "../../store/actions"
const useStyles = makeStyles(theme => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
}))



const CustomButton = styled(Button)({
  boxShadow: 0,
  marginLeft: 5,
  backgroundColor: "#3468C0",
  color: "#yourCustomTextColor",
  "&:hover": {
    backgroundColor: "#2c3e50",
  },
})

function CategoryMaster({
  ShowModalProps,
  isEditProps,
  EditIdProps,
  ComponentProps,
  ShowModal,
  Callback

})  {
  const [tokent, settokent] = useState(
    "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJldmVudGxpc3QiOlt7IlVzZXJJRCI6IjEiLCJMb2dpbkNvZGUiOiIwMSIsIkxvZ2luTmFtZSI6IkFkbWluIiwiRW1haWxJZCI6ImFkbWluQGdtYWlsLmNvbSIsIlVzZXJUeXBlIjoiQURNSU4ifV0sImlhdCI6MTYzODM1NDczMX0.ZW6zEHIXTxfT-QWEzS6-GuY7bRupf2Jc_tp4fXIRabQ"
  )
  const [allcategorycollection, setallcategorycollection] = useState([])
  const classes = useStyles()
  const [modal, setModal] = useState(false)
  const [alltaxcollections, setalltaxcollections] = useState([])
  const [vatpercentagevalue, setvatpercentagevalue] = useState({
    label: "Select...",
    value: "",
  })
  const [catduplicate, setcatduplicate] = useState(false)
  const [activechk, setactivechk] = useState(true)
  const [applicablechk, setapplicablechk] = useState(true)
  const [isEdit, setIsEdit] = useState(false)
  const [deleteModal, setDeleteModal] = useState(false)
  const [SingleCatedata, setSingleCatedata] = useState([])
  const [cateDeleteMsg, setcateDeleteMsg] = useState(false)
  const [cateInsertMsg, setcateInsertMsg] = useState(false)
  const [cateUpdateMsg, setcateUpdateMsg] = useState(false)
  const [descriptionerr, setdescriptionerr] = useState(false)
  const [gsterr, setgsterr] = useState(false)
  const [hsnerr1, sethsnerr1] = useState(false)
  const [hsnerr2, sethsnerr2] = useState(false)
  const [hsnval, sethsnval] = useState("")
  const [codeval, setcodeval] = useState("")
  const [descriptionval, setdescriptionval] = useState("")
  const [EditData, setEditData] = useState([])

  const [Active1, setActive1] = useState(true)

  const [deletemsg, setdeletemsg] = useState(false)
  const [allsuppliercollecions, setallsuppliercollecions] = useState([])
  const [suppliervalue, setsuppliervalue] = useState({
    label: "Select...",
    value: "",
  })
  const [suppliererror, setsuppliererror] = useState(false)

    const pages = [
      5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 100, 150, 200, 250, 300, 400, 500,
      600, 700, 800, 900, 1000,
    ];
    const [page, setpage] = useState(0);
    const [rowsperpage, setrowsperpage] = useState(pages[page]);
  
    const [deletedconfirm, setdeletedconfirm] = useState(false);

    const [deletid, setdeletid] = useState("")
  
    const handleChangePage = (event, newPage) => {
      setpage(newPage);
    };
  
    const handleChangeRowsPerPage = event => {
      setrowsperpage(parseInt(event.target.value, 10));
      // setpage(0);
    };
  
    const changepage = () => {
      return allcategorycollection.slice(
        page * rowsperpage,
        (page + 1) * rowsperpage,
      );
    };
  useEffect(() => {
    GetallCategory1(Active1)
    Getalltax()
    getallcustomers()
  }, [])
  const getallcustomers = async () => {
    const get = await axios.instance
      .get(`/Getonesuppliers/${sessionStorage.getItem("CompanyId")}/${"Y"}`, {
        headers: { Authorization: tokent, "Content-Type": "application/json" },
      })
      .then(res => {
        const data = res.data
        const options = data.map(b => ({
          label: b.customer_name,
          value: b.customer_id,
        }))
        setallsuppliercollecions(options)
      })
  }

  const handleOnClose = (value) => {
    Callback(value);

    
  };
  
  useEffect(() => {
     //console.log(ShowModal,'Callback',ShowModalProps,'ShowModalProps',isEditProps)
      if(ComponentProps){
        if(isEditProps){
          CategoryEditProps()
        }
             if (ShowModalProps)
              {
               setModal(ShowModalProps)
              
               } 
      }
      
      }, [ShowModal])


  const toggle = () => {
    if (modal) {
      if(ComponentProps){
        handleOnClose(true)
      }
      setModal(false)
      setdescriptionval("")
      sethsnval("")
      setvatpercentagevalue({ label: "Select...", value: "" })
      setsuppliervalue({ label: "Select...", value: "" })
      setactivechk(true)
      setActive1(true)
      setIsEdit(false)
      setcodeval("")
      setapplicablechk(true)
    } else {
      setModal(true)
    }
  }

  const [openConfirm, setOpenConfirm] = useState(false)

  const handleClickOpenConfirm = () => {
    setOpenConfirm(true)
  }

  const handleCloseConfirm = () => {
    setOpenConfirm(false)
  }

  const [noRecords, setnoRecords] = useState(false)

  useEffect(() => {
    GetallCategory1(Active1)
  }, [Active1])

  const GetallCategory = async () => {
    const get = await axios.instance
      .get(`/GetallCategoryMst/${"Y"}`, {
        headers: { Authorization: tokent, "Content-Type": "application/json" },
      })
      .then(res => {
        setallcategorycollection(res.data)
      })
  }

  const GetallCategory1 = async id => {
    const get = await axios.instance
      .get(`/GetallCategoryMst/${id === true ? "Y" : "N"}`, {
        headers: { Authorization: tokent, "Content-Type": "application/json" },
      })
      .then(res => {
        const data = res.data
        if (data.length > 0) {
          setallcategorycollection(res.data)
        } else {
          setActive1(true)
          setnoRecords(true)
        }
      })
  }

  const onClickDelete = data => {
    //console.log(data, "value")
    setDeleteModal(true)
    setSingleCatedata(data)
  }

  const Getalltax = async () => {
    const get = await axios.instance
      .get("/Getalltaxper", {
        headers: { Authorization: tokent, "Content-Type": "application/json" },
      })
      .then(res => {
        const data = res.data
        const options = data.map(b => ({
          label: b.Tax_Percentage,
          value: b.Tax_Percentage,
        }))

        setalltaxcollections(options)
      })
  }

  const CategoryDelete = async () => {
    const deletedata = await axios.instance
      .post(
        `/InsertCategory`,
        {
          Category_Id: deletid,
          Category_Code: SingleCatedata.Category_Code,
          Category_Description: SingleCatedata.Category_Description,
          CHSNCode: SingleCatedata.CHSNCode,
          Created_By: SingleCatedata.Created_By,
          Created_Date: SingleCatedata.Created_Date,
          Modify_By: SingleCatedata.Modify_By,
          Modify_Date: SingleCatedata.Modify_Date,
          Active: SingleCatedata.Active,
          ApplicableForAll: SingleCatedata.ApplicableForAll,
          Tax_Id: SingleCatedata.Tax_Id,
          VAT_Percentage: SingleCatedata.VAT_Percentage,
          Optype: "Delete",
        },
        {
          headers: {
            Authorization: tokent,
            "Content-Type": "application/json",
          },
        }
      )
      .then(res => {
        const data = res.data
        if (data.length === 1) {
          setDeleteModal(false)
          setcateDeleteMsg(true)
          setTimeout(() => {
            GetallCategory1(Active1)
          }, 2200)
        } else {
          setDeleteModal(false)
          setdeletemsg(true)
        }
      })
  }

  const CategoryInsert = async () => {
    setOpenConfirm(false)
    // if (suppliervalue.value != 0) {
      const insertdata = await axios.instance
        .post(
          `/InsertCategory`,
          {
            Category_Id: 0,
            Category_Code: 0,
            Category_Description: descriptionval,
            CHSNCode: hsnval,
            Created_By: 1,
            Created_Date: new Date(),
            Active: activechk === true ? "Y" : "N",
            ApplicableForAll: applicablechk === true ? "Y" : "N",
            Tax_Id: 0,
            VAT_Percentage: vatpercentagevalue.value,
            // Ledger_Id: suppliervalue.value,
            Optype: "New",
          },
          {
            headers: {
              Authorization: tokent,
              "Content-Type": "application/json",
            },
          }
        )
        .then(res => {
          if(res.data.length===1){
       
            setcateInsertMsg(true)
            toggle()
            GetallCategory1(Active1)
            if(ComponentProps){
              handleOnClose(true)
            }
          }else{
            setcatduplicate(true)
          }
         
        })
    // } 
    // else {
      // if (suppliervalue.value.length == 0) {
      //   setsuppliererror(true)
      // }
    //   setTimeout(() => {
    //     setsuppliererror(false)
    //   }, 2000)
    // }
  }


  const CategoryEditProps = async() => {
    const get = await axios.instance
    .get(`/GetOnecategorymst/${"Y"}/${EditIdProps}`, {
      headers: { Authorization: tokent, "Content-Type": "application/json" },
    })
    .then(res => {
      setIsEdit(true)
      toggle()
      console.log(res.data)
      for (const data of res.data) {
      
      setcodeval(data.Category_Code)
      sethsnval(data.CHSNCode)
      setvatpercentagevalue({
        label: data.VAT_Percentage,
        value: data.VAT_Percentage,
      })
      setapplicablechk(data.ApplicableForAll === "Y" ? true : false)
      setactivechk(data.Active === "Y" ? true : false)
      setdescriptionval(data.Category_Description)
      setEditData(data)
      setsuppliervalue({
        label: data.Customer_Name,
        value: data.Ledger_Id,
      })
    }
    })
    
  }


  const CategoryEdit = data => {
    setcodeval(data.Category_Code)
    sethsnval(data.CHSNCode)
    setvatpercentagevalue({
      label: data.VAT_Percentage,
      value: data.VAT_Percentage,
    })
    setapplicablechk(data.ApplicableForAll === "Y" ? true : false)
    setactivechk(data.Active === "Y" ? true : false)
    setdescriptionval(data.Category_Description)
    setEditData(data)
    setsuppliervalue({
      label: data.Customer_Name,
      value: data.Ledger_Id,
    })
  }

  const CategoryUpdate = async () => {
    setOpenConfirm(false)
    // if (suppliervalue.value != 0) {
      const updatedata = await axios.instance
        .post(
          `/InsertCategory`,
          {
            Category_Id: EditData.Category_Id,
            Category_Code: EditData.Category_Code,
            Category_Description: descriptionval,
            CHSNCode: hsnval,
            Modify_By: EditData.Modify_By,
            Modify_Date: EditData.Modify_Date,
            Active: activechk === true ? "Y" : "N",
            ApplicableForAll: applicablechk === true ? "Y" : "N",
            Tax_Id: 0,
            VAT_Percentage: vatpercentagevalue.value,
            // Ledger_Id: suppliervalue.value,
            Optype: "Edit",
          },
          {
            headers: {
              Authorization: tokent,
              "Content-Type": "application/json",
            },
          }
        )
        .then(res => {
          setActive1(true)
          setcateUpdateMsg(true)
          toggle()
          GetallCategory1(Active1)
        })
    // } else {
    //   if (suppliervalue.value.length == 0) {
    //     setsuppliererror(true)
    //   }
    //   setTimeout(() => {
    //     setsuppliererror(false)
    //   }, 2000)
    // }
  }

  const columns = useMemo(
    () => [
      {
        Header: "Category Code",
        accessor: "Category_Code",
        filterable: false,
        disableFilters: true,
      },

      {
        Header: "Category Description",
        accessor: "Category_Description",
        filterable: false,
        disableFilters: true,
      },
      {
        Header: "HSNCode",
        accessor: "CHSNCode",
        filterable: false,
        disableFilters: true,
      },
      {
        Header: "GST %",
        accessor: "VAT_Percentage",
        filterable: false,
        disableFilters: true,
      },
      {
        Header: "Supplier Name",
        accessor: "Customer_Name",
        filterable: false,
        disableFilters: true,
      },
      {
        Header: "Action",
        accessor: "action",
        disableFilters: true,
        Cell: cellProps => {
          return (
            <div className="d-flex justify-content-center align-items-center gap-2">
              {/* edit icon */}
              <Tooltip title="Edit" placement="left-start">
                <Link
                  to="#"
                  className="text-primary"
                  onClick={() => {
                    const data = cellProps.row.original
                    setIsEdit(true)
                    toggle()
                    CategoryEdit(data)
                  }}
                >
                  <i
                    className="uil uil-pen font-size-18"
                    id="edittooltip"
                    style={{ color: "blue" }}
                  />
                </Link>
              </Tooltip>

              {/* delete icon */}
              <Tooltip title="Delete" placement="right-end">
                <Link
                  to="#"
                  className="text-danger"
                  onClick={() => {
                    if(JSON.parse(sessionStorage.getItem("MenuItemProductCategoryControls")).Del == "Y"){   
                      const data = cellProps.row.original
                    onClickDelete(data)
                    }else{
                      toastr.warning('Please Contact Admin', 'Operation Not Allowed')
                    } 

                    
                  }}
                >
                  <i
                    className="uil uil-trash-alt font-size-18"
                    id="deletetooltip"
                  />
                </Link>
              </Tooltip>
            </div>
          )
        },
      },
    ],
    []
  )

  return (
    <React.Fragment>
      {/* <DeleteModal
        show={deleteModal}
        onDeleteClick={() => CategoryDelete()}
        onCloseClick={() => setDeleteModal(false)}
      /> */}
      <div className="page-content" style={{ backgroundColor: "inherit" }}>
        <div className="">
          {!ComponentProps &&
          <Row>
            <Col xs="12">
            <h6 className="titleviewinspections">Product Category</h6>
              <Card>
                <CardBody>
                  <div>
                    {/* <Breadcrumbs
                      title="Master"
                      breadcrumbItem="Product Category Master"
                    /> */}
                  </div>
                  <Divider sx={{ mb: 2 }} />
                  <div className="d-flex justify-content-end align-items-center mt-3">
                    <Col
                      xl={12}
                      className="d-flex justify-content-end gap-2 align-items-center"
                    >
                      <div
                        className="d-flex d-flex-column gap-2 justify-content-end align-items-center pr-2"
                        style={{
                          borderRight: "1px solid #61677A",
                          paddingRight: "10px",
                        }}
                      >
                        <h5 className="font-size-14 mt-1">Active Category</h5>
                        <div className="mt-2 ml-2">
                          <Switch
                            onChange={checked => {
                              {
                                checked ? setActive1(true) : setActive1(false)
                              }
                              GetallCategory1(checked)
                            }}
                            checked={Active1}
                            width={40}
                            height={20}
                          />
                        </div>
                      </div>
                      <CustomButton
                        variant="contained"
                        onClick={() => {
                          // if(JSON.parse(sessionStorage.getItem("MenuItemProductCategoryControls")).New == "Y"){   
                            
                            toggle()
                            // }else{
                            //   toastr.warning('Please Contact Admin', 'Operation Not Allowed')
                            // } 
                            
                        }}
                        size="small"
                      >
                        Add Category
                      </CustomButton>
                    </Col>
                  </div>


                  {/* <TableContainer
                    columns={columns}
                    data={allcategorycollection}
                    isGlobalFilter={true}
                    isAddTableWithoutBorderStrap={true}
                  /> */}
                   <div>
                      {/* <Card className="">
                        <CardBody> */}
                      <div className="Tabelinspections">
                        <TableContainer>
                          <Table className="InspectionTbls">
                            <TableHead>
                              <TableRow>
                                <TableCell>Category Code </TableCell>
                                <TableCell align="left">Categoy Description</TableCell>
                                <TableCell align="left">HSN Code</TableCell>
                                <TableCell align="left">GST %</TableCell>
                                {/* <TableCell align="left">Supplier Name</TableCell> */}
                                <TableCell>Edit</TableCell>
                                <TableCell>Delete</TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {allcategorycollection.length != 0 ? (
                                changepage().map((data, index) => (
                                  <TableRow key={index}>
                                    <TableCell style={{ textAlign: "center" }}>
                                      {data.Category_Code}
                                    </TableCell>
                                    <TableCell style={{ textAlign: "left" }}>
                                      {data.Category_Description}
                                    </TableCell>
                                    <TableCell style={{ textAlign: "center" }}>
                                      {data.CHSNCode}
                                    </TableCell>
                                    <TableCell style={{ textAlign: "center" }}>
                                      {data.VAT_Percentage}
                                    </TableCell>
                                    {/* <TableCell style={{ textAlign: "left" }}>
                                      {data.Customer_Name}
                                    </TableCell> */}

                                    <TableCell align="left">
                                      <IconButton size="small">
                                        {/* <VisibilityIcon fontSize="small"  */}
                                        <EditIcon
                                          fontSize="small"
                                          color="primary"
                                          onClick={() => {
                                            // editdata(data);
                                            console.log(data);
                                            // setdeleteid(data.Termsid);
                                            // setisedit(true);
                                            setIsEdit(true)
                                            toggle()
                                            CategoryEdit(data)
                                          }}
                                        />
                                      </IconButton>
                                    </TableCell>
                                    <TableCell align="left">
                                      <IconButton size="small">
                                        <DeleteIcon
                                          color="error"
                                          fontSize="small"
                                          onClick={() => {
                                            // setdeletedconfirm(true);
                                            // setdeleteid(data.Termsid);
                                            setdeletedconfirm(true);
                                            // toggledeletemodal(data.branch_id)
                                            setdeletid(data.Category_Id)
                                          }}
                                        />
                                      </IconButton>
                                    </TableCell>
                                  </TableRow>
                                ))
                              ) : (
                                <TableCell align="left">NO Data Found</TableCell>
                              )}
                            </TableBody>
                          </Table>
                        </TableContainer>

                        <TablePagination
                          component="div"
                          rowsPerPageOptions={pages}
                          count={allcategorycollection.length}
                          rowsPerPage={rowsperpage}
                          page={page}
                          onChangePage={handleChangePage}
                          onChangeRowsPerPage={handleChangeRowsPerPage}
                        />
                      </div>
                      {/* <Backdrop open={open}>
                            <Spinner name="ball-spin-fade-loader" color="#fafafa" />
                            <p style={{ marginTop: '50px' }}></p>
                          </Backdrop> */}
                      {/* </CardBody>
                      </Card> */}

                    </div>
                </CardBody>
              </Card>
            </Col>
          </Row>}
          <Modal isOpen={modal} toggle={toggle} size="md">
            <ModalHeader
              toggle={() => {
                toggle()
                setcodeval("")
                sethsnval("")
                setvatpercentagevalue({ label: "Select...", value: "" })
                setdescriptionval("")
                setIsEdit(false)
              }}
              tag="h4"
            >
              {!!isEdit ? "Edit Category" : "Add Category"}
            </ModalHeader>
            <ModalBody>
              <Row>
                {/* <Col lg="12">
                  <div className="mb-3">
                    <Label htmlFor="manufacturerbrand">
                      <b>
                        Supplier <b className="text-danger">*</b>
                      </b>
                    </Label>
                    <Select
                      options={allsuppliercollecions}
                      classNamePrefix="select2-search-disable"
                      // defaultValue={{'label' : 'All' , 'value' : '0'}}
                      value={suppliervalue}
                      onChange={value => {
                        setsuppliervalue({
                          label: value.label,
                          value: value.value,
                        })
                      }}
                    />
                    {suppliererror ? (
                      <p style={{ fontSize: "12px" }} className="error">
                        Please Select Supplier{" "}
                      </p>
                    ) : null}
                  </div>
                </Col> */}
                <Col lg="6">
                  <div className="mb-3">
                    <Label for="basicpill-lastname-input2">Code</Label>
                    <Input
                      autoComplete="off"
                      type="number"
                      name="code"
                      className="form-control"
                      id="basicpill-lastname-input2"
                      disabled={true}
                      value={codeval}
                      onChange={e => {
                        setcodeval(e.target.value)
                      }}
                    />
                  </div>
                </Col>
                <Col lg="6">
                  <div className="mb-3">
                    <Label for="basicpill-lastname-input2">
                      HSN Code <b className="text-danger">*</b>{" "}
                    </Label>
                    <Input
                      autoComplete="off"
                      type="text"
                      name="hsncode"
                      className="form-control"
                      id="basicpill-lastname-input2"
                      value={hsnval}
                      onChange={e => {
                        sethsnval(e.target.value)
                      }}
                    />
                  </div>
                </Col>
                <Col lg="12">
                  <div className="mb-3">
                    <Label for="basicpill-lastname-input2">
                      Description <b className="text-danger">*</b>
                    </Label>
                    <Input
                      autoComplete="off"
                      type="text"
                      name="description"
                      className="form-control"
                      id="basicpill-lastname-input2"
                      value={descriptionval}
                      onChange={e => {
                        setdescriptionval(e.target.value)
                      }}
                    />
                  </div>
                </Col>

                <Col lg="12">
                  <div className="mb-3">
                    <Label for="basicpill-lastname-input2">
                      GST% <b className="text-danger">*</b>
                    </Label>
                    <Select
                      name="gstper"
                      options={alltaxcollections}
                      classNamePrefix="select2-search-disable"
                      onChange={value => setvatpercentagevalue(value)}
                      value={vatpercentagevalue}
                    />
                  </div>
                </Col>
                <Col lg="6">
                  <div className="checkbox-wrapper-19 d-flex flex-column align-items-center justify-content-center">
                    <div>
                      <input
                        id="active"
                        type="checkbox"
                        // value={'active'}
                        defaultChecked={activechk}
                        onChange={() => setactivechk(state => !state)}
                      />
                      <label className="check-box" htmlFor="active"></label>
                    </div>
                    <div>
                      <label>Active</label>
                    </div>
                  </div>
                </Col>
                <Col lg="6">
                  <div className="checkbox-wrapper-19 d-flex flex-column align-items-center justify-content-center">
                    <div>
                      <input
                        id="appicable"
                        type="checkbox"
                        // value={'applicable'}
                        defaultChecked={applicablechk}
                        onChange={() => setapplicablechk(state => !state)}
                      />
                      <label className="check-box" htmlFor="appicable"></label>
                    </div>
                    <div>
                      <label>Applicable For All</label>
                    </div>
                  </div>
                </Col>
              </Row>
              <Divider sx={{ my: 2 }} />
              <Row>
              <Col lg="12">
                <div className="mt-2 text-end d-flex justify-content-center"
                >
                  {!!isEdit ? (
                    <button
                      type="submit"
                      className="btn btn-success save-user"
                      onClick={e => {
                        e.preventDefault()
                        // if(JSON.parse(sessionStorage.getItem("MenuItemProductCategoryControls")).Edit == "Y"){   
                        
                        
                          
                        if (
                          descriptionval !== "" &&
                          hsnval !== "" &&
                          vatpercentagevalue.value !== ""
                        ) {
                          if (hsnval.length >= 2 && hsnval.length <= 8) {
                            if (applicablechk === false) {
                              CategoryUpdate()
                            } else {
                              handleClickOpenConfirm()
                            }
                          } else {
                            sethsnerr2(true)
                          }
                        } else if (descriptionval === "") {
                          setdescriptionerr(true)
                        } else if (hsnval === "") {
                          sethsnerr1(true)
                        } else if (vatpercentagevalue.value === "") {
                          setgsterr(true)
                        }

                            // }else{
                            //   toastr.warning('Please Contact Admin', 'Operation Not Allowed')
                            // } 
                            
                      }}
                      style={{
                        backgroundColor: "#1746A2",
                        color: "white",
                        border: 0,
                      }}
                    >
                      Update
                    </button>
                  ) : (
                    <button
                     
                      type="submit"
                      className="btn btn-success save-user"
                      onClick={e => {
                        e.preventDefault()
                        // if(JSON.parse(sessionStorage.getItem("MenuItemProductCategoryControls")).New == "Y"){   
                            
                          
                        if (
                          descriptionval !== "" &&
                          hsnval !== "" &&
                          vatpercentagevalue.value !== ""
                        ) {
                          if (hsnval.length >= 2 && hsnval.length <= 8) {
                            if (applicablechk === false) {
                              CategoryInsert()
                            } else {
                              handleClickOpenConfirm()
                            }
                          } else {
                            sethsnerr2(true)
                          }
                        } else if (descriptionval === "") {
                          setdescriptionerr(true)
                        } else if (hsnval === "") {
                          sethsnerr1(true)
                        } else if (vatpercentagevalue.value === "") {
                          setgsterr(true)
                        }

                        console.log('onclick')

                          // }else{
                          //   toastr.warning('Please Contact Admin', 'Operation Not Allowed')
                          // } 
                          
                      }}
                      style={{
                        backgroundColor: "#1746A2",
                        color: "white",
                        border: 0,
                      }}
                    >
                      Add
                    </button>
                  )}
                </div>
                </Col>
              </Row>
            </ModalBody>
          </Modal>
        </div>

        <Dialog
          open={openConfirm}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {
              "Do you want to update the HSN and GST % for all the Products under this Category?"
            }
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              if No please uncheck the Applicable For All check box and save the
              record.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <CustomButton2
              variant="outlined"
              color="warning"
              onClick={handleCloseConfirm}
            >
              Cancel
            </CustomButton2>
            <CustomButton2
              // onClick={CategoryInsert}
              onClick={isEdit ? CategoryUpdate : CategoryInsert}
              variant="contained"
              color="primary"
              autoFocus
            >
              Proceed
            </CustomButton2>
          </DialogActions>
        </Dialog>

        {cateDeleteMsg ? (
          <SweetAlert
            title="Product Category Deleted Successfully"
            timeout={2000}
            style={{
              position: "absolute",
              justifyContent: "center",
              alignItems: "center",
            }}
            showCloseButton={false}
            showConfirm={false}
            success
            onConfirm={() => {
              setcateDeleteMsg(false)
            }}
          ></SweetAlert>
        ) : null}
        {catduplicate ? (
          <SweetAlert
            title="Product Category Already Exists"
            timeout={2000}
            style={{
              position: "absolute",
              justifyContent: "center",
              alignItems: "center",
            }}
            showCloseButton={false}
            showConfirm={false}
            danger
            onConfirm={() => {
              setcatduplicate(false)
            
            }}
          ></SweetAlert>
        ) : null}

        {cateInsertMsg ? (
          <SweetAlert
            title="Product Category Inserted Successfully"
            timeout={2000}
            style={{
              position: "absolute",
              justifyContent: "center",
              alignItems: "center",
            }}
            showCloseButton={false}
            showConfirm={false}
            success
            onConfirm={() => {
              setcateInsertMsg(false)
            }}
          ></SweetAlert>
        ) : null}

        {cateUpdateMsg ? (
          <SweetAlert
            title="Product Category Updated Successfully"
            timeout={2000}
            style={{
              position: "absolute",
              justifyContent: "center",
              alignItems: "center",
            }}
            showCloseButton={false}
            showConfirm={false}
            success
            onConfirm={() => {
              setcateUpdateMsg(false)
            }}
          ></SweetAlert>
        ) : null}

        {hsnerr1 ? (
          <SweetAlert
            title="Please Enter the HSN Code"
            timeout={2000}
            style={{
              position: "absolute",
              justifyContent: "center",
              alignItems: "center",
            }}
            showCloseButton={false}
            showConfirm={false}
            warning
            onConfirm={() => {
              sethsnerr1(false)
            }}
          ></SweetAlert>
        ) : null}

        {hsnerr2 ? (
          <SweetAlert
            title="Please Enter the Valid HSN Code"
            timeout={2000}
            style={{
              position: "absolute",
              justifyContent: "center",
              alignItems: "center",
            }}
            showCloseButton={false}
            showConfirm={false}
            warning
            onConfirm={() => {
              sethsnerr2(false)
            }}
          ></SweetAlert>
        ) : null}

        {descriptionerr ? (
          <SweetAlert
            title="Please Enter the Category Description"
            timeout={2000}
            style={{
              position: "absolute",
              justifyContent: "center",
              alignItems: "center",
            }}
            showCloseButton={false}
            showConfirm={false}
            warning
            onConfirm={() => {
              setdescriptionerr(false)
            }}
          ></SweetAlert>
        ) : null}

        {gsterr ? (
          <SweetAlert
            title="Please Select GST Percentage"
            timeout={2000}
            style={{
              position: "absolute",
              justifyContent: "center",
              alignItems: "center",
            }}
            showCloseButton={false}
            showConfirm={false}
            warning
            onConfirm={() => {
              setgsterr(false)
            }}
          ></SweetAlert>
        ) : null}

        {noRecords ? (
          <SweetAlert
            title="No Records Found for InActive"
            timeout={2000}
            style={{
              position: "absolute",
              justifyContent: "center",
              alignItems: "center",
            }}
            showCloseButton={false}
            showConfirm={false}
            warning
            onConfirm={() => {
              setnoRecords(false)
            }}
          ></SweetAlert>
        ) : null}

        {deletemsg ? (
          <SweetAlert
            title="Transaction Found Can't Be Delete This Record"
            timeout={2000}
            style={{
              position: "absolute",
              justifyContent: "center",
              alignItems: "center",
            }}
            showCloseButton={false}
            showConfirm={false}
            warning
            onConfirm={() => {
              setdeletemsg(false)
            }}
          ></SweetAlert>
        ) : null}

         {deletedconfirm ? (
                <SweetAlert
                  title="Are You Sure?"
                  style={{
                    position: 'absolute',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                  confirmBtnBsStyle="success"
                  showConfirm={true}
                  cancelBtnBsStyle="danger"
                  cancelBtnText="Cancel"
                  confirmBtnText="Yes,delete it!"
                  showCancel={true}
                  warning
                  onConfirm={() => {
                    CategoryDelete();
                    setdeletedconfirm(false);
                  }}
                  onCancel={() => {
                    setdeletedconfirm(false);
                    // setdeleted(false);
                  }}
                >
                  <p style={{ fontSize: '20px' }}>You Won't able to revert this!</p>
                </SweetAlert>
              ) : null}
      </div>
    </React.Fragment>
  )
}

export default CategoryMaster
